require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/set-immediate.js
// module id = 536
// module chunks = 158